import { CheckoutCardConfig } from '../../models/checkout-card/checkout-card-config.type';
import { mockPaysafeConfig } from '../paysafe/paysafe-config.mock';

export const mockCheckoutCardConfig: CheckoutCardConfig = mockPaysafeConfig;
